// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43e3aa76","239":"9edc1032","453":"084809c2","557":"b811f2bb","732":"dc3d1ea0","762":"6afca948"}[chunkId] + ".chunk.js";
};